/**
 * =============================================================================
 * content-collapse.js 
 * =============================================================================
 * Helper for collapsing content - show more/show less
 * =============================================================================
 */

var ContentCollapse = {
  handleContentCollapse: function(e){
    e.preventDefault();
    var parentDiv = this.parentElement;  
    var buttonReadMoreText = document.querySelector('.show-more').dataset.readLessText;
    var buttonReadLessText = document.querySelector('.show-more').dataset.readMoreText;
    if (parentDiv.children[0].className.match(/hide-content/g)) {
      parentDiv.children[0].className='content show-content';
      this.innerText = buttonReadMoreText;
    } else {
      parentDiv.children[0].className='content hide-content';
      this.innerText = buttonReadLessText;
    }
  },

  onReady: function() {
    var buttons = document.querySelectorAll(".show-more");
    buttons.forEach(element => {
      element.addEventListener("click", this.handleContentCollapse);
    });
  }
}

export default ContentCollapse;